import { useQueryClient } from 'react-query'
import companyQueryStrings from '../../Settings/constants/companyQueryStrings'

export default () => {
  const client = useQueryClient()
  return () => client.invalidateQueries(companyQueryStrings.company_inputs)
}
